<div class="editor-container">
  <header class="editor-toolbar">
    <select class="select w-max" (change)="editor?.chain()?.focus()?.setFontSize($any($event.target).value)?.run()">
      <option class="hidden"></option>
      @for (item of fontSizes; track item.value) {
      <option [value]="item.value" [selected]="editor?.isActive('textStyle', { fontSize: item.value })">
        {{ item.name }}
      </option>
      }
    </select>

    <div class="join">
      <button
        type="button"
        data-tip="굵기 적용"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive('bold')"
        (click)="editor?.chain()?.focus()?.toggleBold()?.run()">
        <app-icon class="size-6" name="mdi:format-bold" />
      </button>
      <button
        type="button"
        data-tip="기울이기 적용"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive('italic')"
        (click)="editor?.chain()?.focus()?.toggleItalic()?.run()">
        <app-icon class="size-6" name="mdi:format-italic" />
      </button>
      <button
        type="button"
        data-tip="밑줄 적용"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive('underline')"
        (click)="editor?.chain()?.focus()?.toggleUnderline()?.run()">
        <app-icon class="size-6" name="mdi:format-underline" />
      </button>
      <button
        type="button"
        data-tip="취소선 적용"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive('strike')"
        (click)="editor?.chain()?.focus()?.toggleStrike()?.run()">
        <app-icon class="size-6" name="mdi:format-strikethrough" />
      </button>

      <button
        type="button"
        data-tip="글자색 변경"
        class="gap-0 btn btn-square join-item tooltip"
        (click)="colorInput.click()">
        <input
          #colorInput
          list="colors"
          type="color"
          class="w-0"
          (input)="editor?.chain()?.focus()?.setColor($event.target.value)?.run()" />
        <app-icon
          class="size-6"
          name="mdi:format-color"
          [style.color]="
            editor?.getAttributes('textStyle')?.['color'] ?? 'primary'
          " />
      </button>

      <button
        type="button"
        data-tip="강조 적용"
        class="gap-0 btn btn-square join-item tooltip"
        (click)="highlight.click()">
        <input
          #highlight
          list="colors"
          type="color"
          class="w-0"
          (input)="editor?.chain()?.focus()?.setHighlight({ color: $event.target.value })?.run()" />
        <app-icon
          class="size-6"
          name="mdi:format-color-highlight"
          [style.color]="
            editor?.getAttributes('highlight')?.['color'] ?? 'primary'
          " />
      </button>
    </div>

    <div class="join">
      <button
        type="button"
        data-tip="왼쪽 정렬"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive({ textAlign: 'left' })"
        (click)="editor?.chain()?.focus()?.setTextAlign('left')?.run()">
        <app-icon class="size-6" name="mdi:format-align-left" />
      </button>
      <button
        type="button"
        data-tip="가운데 정렬"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive({ textAlign: 'center' })"
        (click)="editor?.chain()?.focus()?.setTextAlign('center')?.run()">
        <app-icon class="size-6" name="mdi:format-align-center" />
      </button>
      <button
        type="button"
        data-tip="오른쪽 정렬"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive({ textAlign: 'right' })"
        (click)="editor?.chain()?.focus()?.setTextAlign('right')?.run()">
        <app-icon class="size-6" name="mdi:format-align-right" />
      </button>
      <button
        type="button"
        data-tip="양쪽 정렬"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive({ textAlign: 'justify' })"
        (click)="editor?.chain()?.focus()?.setTextAlign('justify')?.run()">
        <app-icon class="size-6" name="mdi:format-align-justify" />
      </button>
    </div>

    @if (!editor?.isActive('table')) {
    <div class="join">
      <button
        type="button"
        data-tip="글머리 기호 목록"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive('bulletList')"
        (click)="editor?.chain()?.focus()?.toggleBulletList()?.run()">
        <app-icon class="size-6" name="mdi:format-list-bulleted" />
      </button>
      <button
        type="button"
        data-tip="번호 매기기 목록"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive('orderedList')"
        (click)="editor?.chain()?.focus()?.toggleOrderedList()?.run()">
        <app-icon class="size-6" name="mdi:format-list-numbered" />
      </button>
    </div>

    <div class="join">
      <button
        type="button"
        data-tip="위첨자"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive('superscript')"
        (click)="editor?.chain()?.focus()?.toggleSuperscript()?.run()">
        <app-icon class="size-6" name="mdi:format-superscript" />
      </button>
      <button
        type="button"
        data-tip="아래첨자"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive('subscript')"
        (click)="editor?.chain()?.focus()?.toggleSubscript()?.run()">
        <app-icon class="size-6" name="mdi:format-subscript" />
      </button>
    </div>
    } @else {
    <div class="join">
      <button
        type="button"
        data-tip="앞에 열 추가"
        class="btn btn-square join-item tooltip"
        (click)="editor?.chain()?.focus()?.addColumnBefore()?.run()">
        <app-icon class="size-6" name="mdi:table-column-plus-before" />
      </button>
      <button
        type="button"
        data-tip="뒤에 열 추가"
        class="btn btn-square join-item tooltip"
        (click)="editor?.chain()?.focus()?.addColumnAfter()?.run()">
        <app-icon class="size-6" name="mdi:table-column-plus-after" />
      </button>

      <button
        type="button"
        data-tip="열 삭제"
        class="btn btn-square join-item tooltip"
        (click)="editor?.chain()?.focus()?.deleteColumn()?.run()">
        <app-icon class="size-6" name="mdi:table-column-remove" />
      </button>

      <button
        type="button"
        data-tip="앞에 행 추가"
        class="btn btn-square join-item tooltip"
        (click)="editor?.chain()?.focus()?.addRowBefore()?.run()">
        <app-icon class="size-6" name="mdi:table-row-plus-before" />
      </button>
      <button
        type="button"
        data-tip="뒤에 행 추가"
        class="btn btn-square join-item tooltip"
        (click)="editor?.chain()?.focus()?.addRowAfter()?.run()">
        <app-icon class="size-6" name="mdi:table-row-plus-after" />
      </button>

      <button
        type="button"
        data-tip="행 삭제"
        class="btn btn-square join-item tooltip"
        (click)="editor?.chain()?.focus()?.deleteRow()?.run()">
        <app-icon class="size-6" name="mdi:table-row-remove" />
      </button>

      <button
        type="button"
        data-tip="셀 병합"
        class="btn btn-square join-item tooltip"
        [disabled]="!editor?.can()?.mergeCells()"
        (click)="editor?.chain()?.focus()?.mergeCells()?.run()">
        <app-icon class="size-6" name="mdi:table-merge-cells" />
      </button>

      <button
        type="button"
        data-tip="셀 분할"
        class="btn btn-square join-item tooltip"
        [disabled]="!editor?.can()?.splitCell()"
        (click)="editor?.chain()?.focus()?.splitCell()?.run()">
        <app-icon class="size-6" name="mdi:table-split-cell" />
      </button>

      <button
        type="button"
        data-tip="표 삭제"
        class="btn btn-square join-item tooltip"
        (click)="editor?.chain()?.focus()?.deleteTable()?.run()">
        <app-icon class="size-6" name="mdi:table-large-remove" />
      </button>
    </div>
    }

    <div class="join">
      <button
        type="button"
        data-tip="링크 삽입"
        popovertarget="link-input"
        style="anchor-name: --link-input-anchor"
        class="btn btn-square join-item tooltip"
        [class.btn-active]="editor?.isActive('link')">
        <app-icon class="size-6" name="mdi:link" />
      </button>

      <div
        popover
        id="link-input"
        #linkInputRef
        class="bg-base-300 rounded-md p-2 w-96"
        style="position-anchor: --link-input-anchor; position-area: bottom span-right">
        <fieldset class="fieldset">
          <legend class="fieldset-legend">링크 추가</legend>
          <div class="flex flex-col gap-2">
            <input #linkTextInput type="text" class="input text-base-content" placeholder="링크 텍스트 (선택사항)" />
            <input
              #urlInput
              type="url"
              class="input text-base-content"
              placeholder="URL을 입력해주세요."
              pattern="^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$" />
            <div class="flex gap-2">
              <button
                type="button"
                class="btn btn-primary flex-1"
                [disabled]="!urlInput.value || !urlInput.validity.valid"
                (click)="
                  insertLinkWithText(urlInput.value, linkTextInput.value);
                  linkInputRef.hidePopover();
                  clearLinkInputs(urlInput, linkTextInput)
                ">
                적용
              </button>
              <button
                type="button"
                class="btn btn-ghost"
                (click)="linkInputRef.hidePopover(); clearLinkInputs(urlInput, linkTextInput)">
                취소
              </button>
            </div>
          </div>
        </fieldset>
      </div>

      <!-- <button
        type="button"
        data-tip="표 삽입"
        class="btn  btn-square join-item tooltip"
        (click)="
          editor
            ?.chain()
            ?.focus()
            ?.insertTable({ rows: 3, cols: 3, withHeaderRow: false })
            ?.run()
        "
      >
        <app-icon class="size-6" name="mdi:table-large-plus" />
      </button> -->

      @if (image()) {
      <button
        type="button"
        data-tip="이미지 삽입"
        class="btn btn-square join-item tooltip"
        (click)="selectImage($event)">
        <app-icon class="size-6" name="mdi:image-plus" />
      </button>
      }

      <button
        type="button"
        data-tip="유튜브"
        class="btn btn-square join-item tooltip"
        [cdkMenuTriggerFor]="youtubeForm">
        <app-icon class="size-6" name="mdi:youtube" />
      </button>
    </div>

    <div class="join">
      <!-- undo -->
      <button
        type="button"
        data-tip="실행 취소"
        class="btn btn-square join-item tooltip"
        (click)="editor?.chain()?.focus()?.undo()?.run()"
        [class.btn-disabled]="!editor?.can()?.undo()">
        <app-icon class="size-6" name="mdi:undo" />
      </button>
      <!-- redo -->
      <button
        type="button"
        data-tip="다시 실행"
        class="btn btn-square join-item tooltip"
        (click)="editor?.chain()?.focus()?.redo()?.run()"
        [class.btn-disabled]="!editor?.can()?.redo()">
        <app-icon class="size-6" name="mdi:redo" />
      </button>
    </div>
  </header>

  <div #editorRef class="editor-content" (click)="editor?.commands?.focus()"></div>
</div>

<datalist id="colors">
  <option>#f5f5f5</option>
  <option>#d4d4d4</option>
  <option>#737373</option>
  <option>#404040</option>
  <option>#171717</option>

  <option>#fca5a5</option>
  <option>#f87171</option>
  <option>#ef4444</option>
  <option>#dc2626</option>
  <option>#b91c1c</option>

  <option>#fdba74</option>
  <option>#fb923c</option>
  <option>#f97316</option>
  <option>#ea580c</option>
  <option>#c2410c</option>

  <option>#fde047</option>
  <option>#facc15</option>
  <option>#eab308</option>
  <option>#ca8a04</option>
  <option>#a16207</option>

  <option>#86efac</option>
  <option>#4ade80</option>
  <option>#22c55e</option>
  <option>#16a34a</option>
  <option>#15803d</option>

  <option>#7dd3fc</option>
  <option>#38bdf8</option>
  <option>#0ea5e9</option>
  <option>#0284c7</option>
  <option>#0369a1</option>

  <option>#93c5fd</option>
  <option>#60a5fa</option>
  <option>#3b82f6</option>
  <option>#2563eb</option>
  <option>#1d4ed8</option>

  <option>#d8b4fe</option>
  <option>#c084fc</option>
  <option>#a855f7</option>
  <option>#9333ea</option>
  <option>#7e22ce</option>
</datalist>

<ng-template #youtubeForm>
  <div class="flex flex-col gap-2 p-4 bg-white shadow-xl" cdkMenu>
    <h5 class="text-sm font-bold">유튜브 동영상 추가</h5>
    <input class="input" placeholder="유튜브 URL" type="url" #youtubeInputRef />

    @if (isYoutubeUrl(youtubeInputRef.value)) {
    <youtube-player [videoId]="getYouTubeVideoId(youtubeInputRef.value)" [width]="300" [height]="300" />
    }

    <button
      class="btn btn-primary btn-sm"
      [disabled]="!isYoutubeUrl(youtubeInputRef.value)"
      (click)="addYoutube(youtubeInputRef.value)"
      cdkMenuItem>
      추가
    </button>
  </div>
</ng-template>
